import { render, staticRenderFns } from "./CommercialBuildings.vue?vue&type=template&id=3bfe09a0&scoped=true&"
import script from "./CommercialBuildings.vue?vue&type=script&lang=js&"
export * from "./CommercialBuildings.vue?vue&type=script&lang=js&"
import style0 from "./CommercialBuildings.vue?vue&type=style&index=0&id=3bfe09a0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfe09a0",
  null
  
)

export default component.exports